// extracted by mini-css-extract-plugin
module.exports = {"saveButtonSpinner":"UserDeleteDialog_saveButtonSpinner__3gnI8"};